module.exports = __webpack_public_path__ + "img/logo_2.77a74bd7.svg";